'use strict';
module.exports = require('mapbox-gl-style-spec/reference/latest');
